import React from 'react';
import { Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

export const TruncatedTextCell = ({ maxLength,
  text,
  textStyle = 'bodyMd600',
  textAlign = 'left',
  duskSelector = undefined }) => (
    <Tooltip isDisabled={text.length < maxLength} label={text}>
      <Text
        dusk={duskSelector}
        noOfLines={1}
        textAlign={textAlign}
        textStyle={textStyle}
      >
        {text}
      </Text>
    </Tooltip>
);

TruncatedTextCell.propTypes = {
  text: PropTypes.string,
  maxLength: PropTypes.number,
  textStyle: PropTypes.string,
  textAlign: PropTypes.string,
  duskSelector: PropTypes.string
};
